import { Component, OnInit, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Component({
  selector: 'site-map-childs',
  template: `
  <li *ngFor="let menu of childs;let i=index">
    <span>
        <a *ngIf="menu.type == 1" [href]="menu.url">
            <i class="fa fa-{{menu.icon}}"></i> {{menu.name}}
        </a>

        <a *ngIf="menu.type ==2" [routerLink]="getPageSlug(menu.pageId)">
            <i class="fa fa-{{menu.icon}}"></i> {{menu.name}}
        </a>

        <a *ngIf="menu.type == 3">
            <i class="fa fa-{{menu.icon}}"></i> {{menu.name}}
        </a>

        <a *ngIf="menu.type == 4" [routerLink]="'/'+menu.slug">
            <i class="fa fa-{{menu.icon}}"></i> {{menu.name}}
        </a>

        <a *ngIf="menu.type ==5">
            <i class="fa fa-{{menu.icon}}"></i> {{menu.name}}
        </a>
          <a *ngIf="menu.type == 6" [routerLink]="'/'+menu.slug">
            <i class="fa fa-{{menu.icon}}"></i> {{menu.name}}
        </a>
    </span>
    <ul *ngIf="menu.childs&&menu.childs.length">
        <site-map-childs [allPages]="allPages" [settings]="settings" [childs]="menu.childs">
        </site-map-childs>
    </ul>
</li>
  `
})
export class SiteMapChildsComponent implements OnInit {
  @Input() settings: any
  @Input() childs;
  @Input() allPages;

  constructor() { }

  ngOnInit() {

  }

  navigateToSection(el) {
    var elmnt = document.getElementById(el);
    elmnt.scrollIntoView();
  }


  getPageSlug(id) {
    for (let i = 0; i < this.allPages.length; i++) {
      const p = this.allPages[i];
      if (p.id == id) {
        return '/' + p.slug
      }
    }
    return this.allPages[0] ? this.allPages[0].slug : null;
  }
}

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.css']
})
export class SitemapComponent implements OnInit {
  @Input() settings: any
  @Input() data: any

  searchText: any;
  menus: any[] = [];
  allPages: any[] = [];
  site: any;
  siteName: any;
  HostName: any;
  constructor(private httpClient: HttpClient) { }

  ngOnInit() {
    this.site = this.data.moduleService.site
    this.siteName = this.data.moduleService.site.name;
    this.HostName = this.data.moduleService.site.HostName;
    this.GetCategoryMenus(this.settings.selectedCategory);
    this.GetAllPages()
  }

  GetCategoryMenus(id) {
    if (this.data.dataChashingService && this.data.dataChashingService.menusCategories[id]) {
      this.menus = this.data.dataChashingService.menusCategories[id];
      this.data.SharedService.setCurrentMenu(id)

    } else
      this.httpClient.get(`/Menus/GetMenusByCategoryId/${id}/2`).subscribe((res: any) => {
        this.data.dataChashingService.menusCategories[id] = res
        this.menus = res.result;
        this.sortMenu(this.menus);
        this.data.SharedService.setCurrentMenu(id)
      });
  }

  sortMenu(menuItems) {
    menuItems.sort((a, b) => {
      return a.order - b.order;
    });
    menuItems.forEach(element => {
      if (element.childs.length > 1) {
        this.sortMenu(element.childs);
      }
    });
  }

  GetAllPages() {
    if (this.data.dataChashingService && this.data.dataChashingService.pagesList) {
      this.allPages = this.data.dataChashingService.pagesList;
    } else {
      const requestOptions = {
        headers: new HttpHeaders({
          'siteId': this.site.id + ''
        }),
      };
      this.httpClient.get('/Pages/GetAllPages', requestOptions).subscribe((res: any) => {
        this.data.dataChashingService.pagesList = res;
        this.allPages = res;
      });
    }
  }

  getPageSlug(id) {
    for (let i = 0; i < this.allPages.length; i++) {
      const p = this.allPages[i];
      if (p.id == id) {
        return '/' + p.slug
      }
    }
    return this.allPages[0] ? this.allPages[0].slug : null;
  }

}
